const onlyDigits = (string = '') => string
  .replace(/\D+/g, '');
export default onlyDigits;